import ReactDOM from 'react-dom/client';
import App from './App';
import AuthProvider from 'react-auth-kit';
import { store } from './authconfig';
import { createStandaloneToast } from '@chakra-ui/react'

const { ToastContainer } = createStandaloneToast()


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AuthProvider store={store}>
    <App />
    <ToastContainer/>
  </AuthProvider>
);
